import * as React from 'react';
import styled from 'styled-components';
import { getColorShades } from '../../../lib/utils';
import { appHeaderProgressLineHeight } from '../../cssConstants';

const ProgressLine = ({
	currentStep = 0,
	totalStep = 0,
	color = '',
	height = appHeaderProgressLineHeight,
	className = ''
}: Props) => {
	const { light, dark } = getColorShades(color);
	const monoColor = !light && !dark ? color : '';

	return (
		<StepperContainer className={className}>
			<StepsWrapper>
				<LineWrapper $height={height} className="line-wrapper">
					<Line
						$lightColor={light}
						$darkColor={dark}
						$monoColor={monoColor}
						$currentStep={Math.min(currentStep, totalStep)}
						$totalSteps={totalStep}
					/>
				</LineWrapper>
			</StepsWrapper>
		</StepperContainer>
	);
};

export default ProgressLine;

interface Props {
	currentStep?: number;
	totalStep?: number;
	color?: string;
	height?: string;
	className?: string;
}

const StepperContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
`;

const StepsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
`;

const LineWrapper = styled.div<{ $height: string }>`
	width: 100%;
	height: ${({ $height }) => $height};
	background-color: #d1d5db; /* Inactive background color */
	position: relative;
	margin-bottom: 20px;
	border-radius: 12px;
`;

const Line = styled.div<{
	$monoColor: string;
	$lightColor?: string;
	$darkColor?: string;
	$currentStep: number;
	$totalSteps: number;
}>`
	height: 100%;
	border-radius: 12px;
	background: ${({ $lightColor, $darkColor, $monoColor }) =>
		$lightColor && $darkColor ? `linear-gradient(175deg, ${$lightColor}, ${$darkColor})` : $monoColor};
	width: ${({ $currentStep, $totalSteps }) => ($currentStep / $totalSteps) * 100}%;
	transition: width 0.3s ease-in-out;
	position: absolute;
	top: 0;
	left: 0;
`;
